module.exports = __webpack_public_path__ + "img/reporting_posts_numbers.091edf7f.svg";